export function TargetElderlyIcon({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g id="trekking">
      <path id="Vector" d="M24 13.3333L20 15.3333L14.6667 11.3333L13.3333 18.6667L18 22.6667L18.6667 28.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_2" d="M24 11.3333V13.3333V28.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_3" d="M13.3333 22.6667L10.6667 28.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_4" d="M11.3333 11.3333C9.33333 12.6667 8 16 8 16L10.6667 17.3333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path id="Vector_5" d="M16 8.66667C17.4728 8.66667 18.6667 7.47276 18.6667 6C18.6667 4.52724 17.4728 3.33333 16 3.33333C14.5272 3.33333 13.3333 4.52724 13.3333 6C13.3333 7.47276 14.5272 8.66667 16 8.66667Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  )
}
